import { CheckoutEvents } from '@mc/pre-paywall-events'
import { track, getPageSource } from '@mc/track-event'
import { Vendor, Location } from './data'

type Props = { vendor: `${Vendor}` }
export const trackPopUpVendorClicked = ({ vendor }: Props) => {
  track(CheckoutEvents.EVENTS.SOCIAL_VENDOR_LOG_IN_INITIATED, {
    location: Location.POP_UP,
    page_source: getPageSource(),
    social_sign_on_vendor: vendor,
  })
}
